import Carrier from ".";

export const CarrierRoutes = [
  {
    path: "/carrier",
    element: <Carrier />,
  },
];
